import React, { useCallback } from "react";
import SearchField from "Components/Fragment/SearchField";

const InputTextSearch = ({
  searchText,
  setSearchText,
  onSearch,
  languageContext,
  fullWidth = true,
  sx,
}) => {
  const handleSearch = useCallback(() => {
    onSearch(searchText);
  }, [onSearch, searchText]);

  const handleClear = useCallback(() => {
    setSearchText("");
    onSearch("");
  }, [setSearchText, onSearch]);

  const handleChange = useCallback(
    (e) => {
      setSearchText(e.target.value);
    },
    [setSearchText],
  );

  return (
    <SearchField
      value={searchText}
      placeholder={languageContext("search")}
      clearLabel={languageContext("clearSearch")}
      searchLabel={languageContext("search")}
      onChange={handleChange}
      onSearch={handleSearch}
      onClear={handleClear}
      onBlur={handleSearch}
      searchMode="onSubmit"
      sx={{ maxHeight: "46px", ...(sx || {}) }}
      fullWidth={fullWidth}
    />
  );
};

export default InputTextSearch;
